import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CommonService } from '@sharedModule/services/common/common.service';
import { switchMap, map, catchError, of } from 'rxjs';
import {
  loadDestinationCountry,
  loadDestinationCountrySuccess,
  loadDestinationCountryFailure,
} from './destination-country.actions';

@Injectable()
export class DestinationCountryEffect {
  loadDestinationCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDestinationCountry),
      switchMap(({ payload }) =>
        this.commonService.getDestinationCountryList(payload).pipe(
          map(data => {
            if (data.response) {
              return loadDestinationCountrySuccess({
                destinationCountries: data.response.destination_currency,
                sourceCurrency: data.response.source_currency,
              });
            } else {
              return loadDestinationCountryFailure({ error: 'no data found' });
            }
          }),
          catchError(error =>
            of(loadDestinationCountryFailure({ error: error.error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private commonService: CommonService
  ) {}
}
